import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col bg-gray-50 h-screen" }
const _hoisted_2 = { class: "flex flex-col mt-16" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"\"><a href=\"/\" class=\"flex items-center text-sm text-gray-400\"><div class=\"shrink-0 pl-6 pr-4\"><svg class=\"fill-secondary rotate-180\" width=\"9\" height=\"40\" viewBox=\"0 0 9 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.02899 20.4773L2.56306 25.9432C2.29944 26.2068 1.87206 26.2068 1.60847 25.9432L0.97096 25.3057C0.707794 25.0425 0.707288 24.616 0.969835 24.3522L5.30168 20L0.969835 15.6478C0.707288 15.384 0.707794 14.9575 0.97096 14.6943L1.60847 14.0568C1.87208 13.7932 2.29947 13.7932 2.56306 14.0568L8.02896 19.5227C8.29257 19.7863 8.29257 20.2137 8.02899 20.4773Z\"></path></svg></div><div class=\"grow py-5\"><div class=\"text-sm text-gray-400\">Tur liste</div><h1 class=\"text-xl font-medium text-primary\">Dine allokerede ture</h1></div></a></div>", 1)
const _hoisted_4 = { class: "space-y-4" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "text-xl font-medium text-primary" }
const _hoisted_9 = { class: "text-xl font-medium text-primary" }
const _hoisted_10 = { class: "text-sm text-gray-400 flex justify-between" }
const _hoisted_11 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headerComponent = _resolveComponent("headerComponent")!
  const _component_listItemBookingComponent = _resolveComponent("listItemBookingComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_headerComponent),
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookingList, (row) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "bg-white px-6 py-5 text-sm text-gray-400",
              value: row.value,
              key: row.value
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h1", _hoisted_8, _toDisplayString(row.trailerName), 1),
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.getTemperatureFromTrailerId(row.trailerId)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(row.departureDate), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.bookings, (subRow) => {
                return (_openBlock(), _createElementBlock("ul", {
                  role: "list",
                  class: "divide-y divide-gray-200 border-y border-gray-200 p-0",
                  value: subRow.value,
                  key: subRow.value
                }, [
                  _createVNode(_component_listItemBookingComponent, { data: subRow }, null, 8, ["data"])
                ], 8, _hoisted_11))
              }), 128))
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}